import React, { useState } from 'react'
import '../style/common/Header.scss'
import { Box, Button, Divider, Typography } from '@mui/material'
import RefreshIcon from '../assets/Icons/RefreshIcon'
import TextBox from './TextBox'
import TicketSearch from '../components/modal/TicketSearch'
import TicketDetails from '../components/modal/TicketSearch/TicketDetails'
import Recharge from '../components/modal/Recharge'
import SearchIcon from '../assets/Icons/SearchIcon'
import { useDispatch, useSelector } from 'react-redux'
import { getBookingsLoad, getCompanyAgentsRightsListAll } from '../redux/Booking/BookingActions'
import { showErrorAlert } from '../redux/Actions'
import UserMenu from '../components/Booking/UserMenu'
import TimeClock from './TimeClock'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import BookingTableModal from '../components/modal/TicketSearch/BookingTableModal'
import { formatBookingListData } from '../utils/helpers'
import dayjs from 'dayjs'

const Header = (props) => {
    const { handleRefresh = () => { }, bkgDeatails = {}, showLogoHeader, setShowLogoHeader, } = props
    const dispatch = useDispatch();
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;
    const [openModal, setOpenModal] = useState({
        id: 0,
        open: false,
        data: {},
    })
    const [openListModal, setOpenListModal] = useState({
        id: 0,
        open: false,
        data: [],
    })

    const handleLoad = (searchType = 'P', bookingID = 0, isFromModal = false) => {

        if (bookingID?.toString()?.trim() === '') {
            dispatch(showErrorAlert("Enter Any Value"))
            return
        }
        if (searchType === 'S' && Object.keys(bkgDeatails.tripDetails || {}).length === 0) {
            dispatch(showErrorAlert("Seat No Search is only available when trip is selected"))
            return
        }
        const body = {
            intUserID: 0,
            strSearchType: searchType,
            intBookingID: searchType === 'P' ? bookingID : 0,
            strSeatNo: searchType === 'S' ? bookingID.toString()?.toUpperCase() : '',
            intTripID: searchType === 'S' ? bkgDeatails.tripDetails?.TripID || 0 : 0,
            dtJourneyDate: searchType === 'S' ? dayjs(bkgDeatails.tripDetails?.JourneyDate, 'DD-MMM-YYYY').format("YYYY-MM-DD") : '0001-01-01',
            intFromCityId: searchType === 'S' ? bkgDeatails.tripDetails?.FromCityID || 0 : 0,
            intToCityID: searchType === 'S' ? bkgDeatails.tripDetails?.ToCityID || 0 : 0,
            intAgentUserID: userDetails?.AgentUserID || 0,
            strContactNo: searchType === 'M' ? bookingID : '',
            strPassengerEmailID: searchType === 'E' ? bookingID : '',
            strTicketNo: searchType === 'T' ? bookingID : '',
        }

        dispatch(getBookingsLoad(body)).then((res) => {
            if (res.data.status) {
                let parseData = JSON.parse(res.data.Data)
                if (parseData?.Table.length !== 0 && parseData?.Table1.length !== 0) {
                    if (searchType !== 'P' && parseData?.Table?.length > 1) {
                        setOpenListModal((prev) => ({
                            ...prev,
                            id: 1,
                            open: true,
                            data: formatBookingListData(parseData?.Table || []),
                        }))
                        return
                    }
                    const roleBody = {
                        intUserID: userDetails?.AgentUserID || 0,
                        intCompanyID: parseData?.Table?.[0]?.CompanyID,
                        intAgentID: userDetails?.AgentID || 0,
                    }
                    dispatch(getCompanyAgentsRightsListAll(roleBody)).then((roleRes) => {
                        if (roleRes.data?.status) {
                            let roleRight = JSON.parse(roleRes?.data.Data || '{}')?.Table?.[0] || {}
                            let checkCancelRole = parseData?.Table?.[0]?.BookingType === "AC" ? roleRight.AllowConfirmCancel === 1 : roleRight.AllowPhoneCancel === 1
                            let checkConfirmRole = parseData?.Table?.[0]?.BookingType === "AP" && roleRight.AllowPhoneModify === 1
                            setOpenModal((prev) => ({
                                ...prev,
                                id: 2,
                                open: true,
                                data: { ...parseData, cancelRole: checkCancelRole, confirmRole: checkConfirmRole },
                            }))
                            if (isFromModal) {
                                setOpenListModal((prev) => ({
                                    ...prev,
                                    id: 0,
                                    open: false,
                                    data: [],
                                }))
                            }
                        } else {
                            dispatch(showErrorAlert(roleRes.data.Message || ''))
                        }
                    })

                } else {
                    dispatch(showErrorAlert('No Found data'))
                }
            } else {
                dispatch(showErrorAlert(res.data.Message || ''))
            }
        })
    }
    return (
        <>
            <Box className='header_container'>
                <Box className='left_section'>
                    <Typography className='header_user'>Welcome {userDetails.AgentUserName || ''}</Typography>
                    <Divider orientation="vertical" flexItem sx={{ borderColor: '#FFFFFFB2' }} />
                </Box>
                <Box className='time_clock'>
                    <TimeClock />
                </Box>
                <Box className='right_section'>
                    <Box className='smallTextBox26 pnrSearch_box' >
                        <SearchIcon />
                        <TextBox onClick={() => {
                            setOpenModal((prev) => ({
                                ...prev,
                                id: 1,
                                open: true,
                                data: {}
                            }))
                        }}
                            placeholder='Search'
                        />
                    </Box>
                    <Divider orientation="vertical" flexItem sx={{ borderColor: '#FFFFFFB2' }} />

                    {Object.keys(bkgDeatails.tripDetails || {}).length !== 0 &&
                        <>
                            <Box className='header_balance'>
                                <span>
                                    <span>{Number(bkgDeatails?.agentBalance) > 0 ? 'PRE' : "POST"}</span>
                                </span>
                            </Box>
                            <Box className='header_balance'
                            // onClick={() => {
                            //     setOpenModal((prev) => ({
                            //         ...prev,
                            //         id: 3,
                            //         open: true,
                            //         data: {}
                            //     }))
                            // }}
                            >
                                <span>
                                    <span> BAL:</span>
                                    <span>{Number(bkgDeatails?.agentBalance) > 0 ? bkgDeatails?.agentBalance : 0}</span>
                                </span>
                            </Box>
                        </>
                    }

                    {showLogoHeader &&
                        <Box onClick={() => {
                            localStorage.setItem('logoHeaderHide', true)
                            setShowLogoHeader(true)
                        }} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <AddCircleOutlineIcon sx={{ fontSize: '20px', color: '#FFFFFF' }} />
                        </Box>
                    }
                    <Box onClick={handleRefresh} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <RefreshIcon />
                    </Box>
                    <UserMenu />
                </Box>
            </Box>
            {openModal.open &&
                <>
                    {openModal.id === 1 &&
                        <TicketSearch open={openModal.id === 1} titleText='Search By' onClose={() => {
                            setOpenModal((prev) => ({
                                ...prev,
                                id: 0,
                                open: false,
                                data: {}
                            }))
                        }}
                            handleLoad={handleLoad}
                        />
                    }
                    {openModal.id === 2 &&
                        <TicketDetails open={openModal.id === 2} titleText={'Ticket Details'}
                            data={openModal.data || {}}
                            onClose={() => {
                                setOpenModal((prev) => ({
                                    ...prev,
                                    id: 0,
                                    open: false,
                                    data: {}
                                }))
                            }} />
                    }
                    {openModal.id === 3 &&
                        <Recharge open={openModal.id === 3} titleText='Recharge' onClose={() => {
                            setOpenModal((prev) => ({
                                ...prev,
                                id: 0,
                                open: false,
                                data: {}
                            }))
                        }} />
                    }
                </>
            }
            {openListModal.open &&
                <>
                    <BookingTableModal open={openListModal.open && openListModal.id === 1} data={openListModal.data || []}
                        titleText='Booking Details'
                        handleLoad={(type, id) => {
                            handleLoad(type, id, true)
                        }}
                        onClose={() => {
                            setOpenListModal((prev) => ({
                                ...prev,
                                id: 0,
                                open: false,
                                data: []
                            }))
                        }}
                    />
                </>
            }
        </>
    )
}

export default Header